import React from "react";
import { useGlobal } from "utils/globalState";
import { useHistory } from "react-router-dom";

import { trackEvent } from "@jsainsburyplc/id-ui-common";

import useCookies from "hooks/useCookies";
import { otpService } from "services/otp.service";
import { getAccountRecoveryOtpLink } from "utils/urls";
import { scrollToTop } from "utils/scrollToTop";
import { accountRecoveryUserData } from "constants/mfaAndOtp";
import { actionTypes, categoryTypes } from "constants/tracking";

import PageFormat from "components/PageFormat";
import InitiateAccountRecoveryForm from "components/AccountRecovery/InitiateAccountRecoveryForm";
import StillHavingTrouble from "components/StillHavingTrouble";

const trackFormSubmit = (action) => {
  trackEvent({
    category: categoryTypes.ACCOUNT_RECOVERY,
    label: "Last Name and Email Form",
    action,
  });
};

const InitiateAccountRecoveryPage = () => {
  const [, setUserData] = useGlobal(accountRecoveryUserData);
  const { setEmail } = useCookies();
  const history = useHistory();

  const handleSubmit = async ({ email, lastName }, actions) => {
    const { setSubmitting, setStatus } = actions;
    try {
      setSubmitting(true);
      const response = await otpService.requestAccountRecoveryOtp(
        email,
        lastName
      );
      if (response.ok) {
        setEmail(email, { path: "/" });
        setSubmitting(false);
        setUserData({ email, lastName });
        history.push(getAccountRecoveryOtpLink());
        trackFormSubmit(actionTypes.SUCCESS);
        return;
      } else {
        throw Error;
      }
    } catch {
      trackFormSubmit(actionTypes.ERROR);
      setStatus({ isError: true });
      setSubmitting(false);
      scrollToTop();
    }
  };

  return (
    <PageFormat>
      <div className="c-hero c-hero--center">
        <h1>We need some details</h1>
      </div>
      <p>
        Enter the email address associated with your account and your last name.
      </p>
      <p>
        Don’t worry if you aren’t able to access that email, we just need it to
        find your account. We’ll then send a code via SMS.
      </p>
      <InitiateAccountRecoveryForm onSubmit={handleSubmit} />
      <StillHavingTrouble />
    </PageFormat>
  );
};

export default InitiateAccountRecoveryPage;
